import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import btnClose from '../../images/common/close.svg';
import { mediaType } from '../../lib/constants';
import imgMusic from '../../images/media/ic_music.svg';
import MessagePlaceholder from '../Parts/MessagePlaceholder';
import ColorSF2 from '../../styles/common/ColorSF2';

const MainBlock = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;
const DialogBox = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${ColorSF2.white};
`;
const HeaderBlock = styled.div`
  padding-left: 18px;
  height: 64px;
  background-color: ${ColorSF2.paleBlue};
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  font-weight: bold;
`;
const CloseButton = styled.div`
  margin: 20px 18px 20px 18px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const CloseButtonImage = styled.img`
  width: 20px;
  height: 20px;
`;
const BodyBlock = styled.div`
  height: calc(100% - 67px);
  width: 100%;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: start;
`;
const MediaImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
`;
const MediaVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
const AudioWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${ColorSF2.navyBlue};
  display: flex;
  align-items: center;
  flex-direction: column;
`;
const AudioPlayer = styled.audio`
  margin-bottom: 15px;
`;
const MusicIcon = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 180px;
`;

const ActionLogMediaDialog = ({ media, onCloseDialog }) => (
  <MainBlock
    id="closeBlackboardListDialog"
    role="presentation"
    onClick={() => onCloseDialog()}
  >
    <DialogBox role="presentation" onClick={e => e.stopPropagation()}>
      <HeaderBlock>
        <FormattedMessage id="actionLog.media.title" />
        <CloseButton
          id="closeButton"
          role="presentation"
          className="button"
          onClick={() => onCloseDialog()}
        >
          <CloseButtonImage src={btnClose} alt="close" />
        </CloseButton>
      </HeaderBlock>
      <BodyBlock>
        {media.type === mediaType.image && (
          <MediaImage src={media.url} alt="img" />
        )}
        {media.type === mediaType.video && (
          <MediaVideo
            src={media.url}
            controls
            autoPlay
            controlsList="nodownload"
          >
            <track kind="captions" />
          </MediaVideo>
        )}
        {media.type === mediaType.audio && (
          <AudioWrapper>
            <MusicIcon>
              <img src={imgMusic} alt="" />
            </MusicIcon>
            <AudioPlayer
              src={media.url}
              controls
              autoPlay
              controlsList="nodownload"
            >
              <track kind="captions" />
            </AudioPlayer>
          </AudioWrapper>
        )}
        {media.type === mediaType.none && <MessagePlaceholder />}
      </BodyBlock>
    </DialogBox>
  </MainBlock>
);

ActionLogMediaDialog.propTypes = {
  media: PropTypes.object.isRequired,
  onCloseDialog: PropTypes.func.isRequired,
};

export default ActionLogMediaDialog;
